export default {
  storeNamespace: 'product',
  authFeature: 'product',
  detailRouteName: "ProductMobileDetail",
  titleField: 'name',
  fields: [{
    name: 'name',
    label: "Nom",
    type: 'text',
    inDetail: true,
  },
  {
    name: 'internal_code',
    label: "Code interne",
    type: 'text',
    inDetail: true,
  },
  {
    name: 'picture',
    inDetail: true,
  },
  {
    name: 'equipment_group',
    label: "Famille",
    type: 'select',
    inDetail: true,
    formatter: (context, value) => value && value.name ? value.name : null
  },
  {
    name: 'axiloc_id',
    label: "ID Axiloc",
    type: 'number',
    inDetail: true,
  },
  {
    name: 'stock',
    label: "Stock réel",
    type: 'number',
    inDetail: true,
  },
  {
    name: 'rent_count',
    label: "En location",
    type: 'number',
    inDetail: true,
  },
  {
    name: 'maintenance_count',
    label: "En maintenance",
    type: 'number',
    inDetail: true,
  },
  {
    name: 'lost_count',
    label: "Perdu/Volés",
    type: 'number',
    inDetail: true,
  },
  {
    name: 'trash_count',
    label: "Au rebut",
    type: 'number',
    inDetail: true,
  },
  {
    name: 'supplier',
    label: "Fournisseur",
    type: 'select',
    inDetail: true,
    formatter: (context, value) => value ? value.name : null
  },
  {
    name: 'brand',
    label: "Marque",
    type: 'text',
    inDetail: true,
  },
  {
    name: 'model',
    label: "Modèle",
    type: 'text',
    inDetail: true,
  },
  {
    name: 'calibration_periodicity',
    label: "Périodicité d'étalonnage / Contrôle obligatoire",
    type: 'number',
    inDetail: true,
    formatter: (context, value) => value ? value + ' jours' : null
  },
  {
    name: 'calibration_provider',
    label: "Organisme d'étalonnage",
    type: 'select',
    inDetail: true,
    detailLink: 'CompanyDetail',
    formatter: (context, value) => value ? value.name : null
  },
  {
    name: 'stock_mini',
    label: "Stock minimum",
    type: 'number',
    inDetail: true,
  },
  {
    name: 'group_slug',
    label: "Service",
    type: 'select',
    inDetail: true,
    formatter: (context, value) => value ? context.$store.getters['renting_preparation/getGroup'](value).text : null
  },
  {
    name: 'comment',
    label: "Commentaire",
    type: 'textarea',
    inDetail: true,
  },
  {
    name: 'purchase_price',
    label: "Prix d'achat unitaire HT",
    type: 'number',
    inDetail: true,
    formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
  },
  {
    name: 'sale_price',
    label: "Prix de vente HT",
    type: 'number',
    inDetail: true,
    formatter: (context, value) => value ? parseFloat(value).toFixed(2) : null
  },
  {
    name: 'total_turnover',
    label: "Montant total des ventes",
    type: 'number',
    inDetail: true,
    formatter: (context, value) => (value ? parseFloat(value).toFixed(2) : 0) + '€'
  },
  {
    name: 'total_cost',
    label: "Cout total des achats",
    type: 'number',
    inDetail: true,
    formatter: (context, value) => (value ? parseFloat(value).toFixed(2) : 0) + '€'
  },
  {
    name: 'created_at',
    label: "Création",
    type: 'date',
    inDetail: true,
    formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
  },
  {
    name: 'updated_at',
    label: "Dernière modification",
    type: 'date',
    inDetail: true,
    formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
  },
  ]
}



// WEBPACK FOOTER //
// ./src/components/ProductMobile/config.js